import { BASE } from "./index";
import axios from "./http";

const logisticscity = {

  // 集配后台城市仓列表
  logisticslist: (params) =>
    axios.post(`${BASE.PRO2}/logistics/list/page`, params),
  // 集配后台城市仓变更记录列表
  logisticsvehiclelog: (params) =>
    axios.post(`${BASE.PRO2}/logistics/vehicle/log`, params),
   // 集配后台自提点列表
  deliverylist: (params) =>
    axios.post(`${BASE.PRO2}/delivery/list/page`, params),
};
 

export default logisticscity;
